import { coneoWdConfig } from './function-modules/coneo-wd/coneo-wd.config';
import { coneoWd2cConfig } from './function-modules/coneo-wd2c/coneo-wd2c.config';

/**
 * ホームURL
 */
export const HOME_URL = 'portal';

/**
 * メニュー
 */
export const MENU_DEFINITION: {label: string; menuItems: {label: string, path: string}[]}[] = [
  coneoWdConfig,
  coneoWd2cConfig,
  {
    label: 'ロジKPI',
    menuItems: [
      { label: '出荷', path: 'logi-kpi/shipments' },
      { label: '設定', path: 'logi-kpi/vol-settings' }
    ]
  },
  {
    label: '管理',
    menuItems: [
      { label: 'ユーザー', path: 'users' }
    ]
  }
];
